import { inject } from '@angular/core'
import { signalStore, withMethods } from '@ngrx/signals'
import { rxMethod } from '@ngrx/signals/rxjs-interop'
import { User } from 'oidc-client-ts'
import { delay, switchMap, tap } from 'rxjs/operators'
import { from } from 'rxjs'
import { ProfileStore } from '@core/store/profile/profile.store'
import { TenantStore } from '@core/store/tenant/tenant.store'

export const StartupStore = signalStore(
  { providedIn: 'root' },
  withMethods(() => {
    const profileStore = inject(ProfileStore)
    const tenantStore = inject(TenantStore)

    return {
      startup: rxMethod<User>((source$) =>
        source$.pipe(
          tap((oidc) => profileStore.setOidcUser(oidc)),
          delay(0),
          switchMap(() =>
            from([
              profileStore.fetchMCUSer(),
              profileStore.fetchUserProfile(),
              tenantStore.fetchTenants(),
            ]),
          ),
        ),
      ),
    }
  }),
)
